export function showLoading(loadingParams) {
    window.appBridge.showLoading(loadingParams)
}

export function hideLoading() {
    window.appBridge.hideLoading()
}



// WEBPACK FOOTER //
// ./src/util/bridge.js